import { render } from "./ResponsiveTableItem.vue?vue&type=template&id=311cc036&scoped=true"
import script from "./ResponsiveTableItem.vue?vue&type=script&lang=js"
export * from "./ResponsiveTableItem.vue?vue&type=script&lang=js"

import "./ResponsiveTableItem.vue?vue&type=style&index=0&id=311cc036&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311cc036"]])

export default __exports__